/**
 * Date/time shapes shared by the live i18n instance and the test mount
 * helper. Side-effect free on purpose: the live module creates a singleton
 * that reads localStorage at import time, and the test helper used to carry
 * a copy of these to avoid it — until the copy drifted and a format that
 * existed in the app did not exist in the tests.
 */
export const dateFormats = {
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
  // A whole calendar month names itself — "agosto 2026" — rather than being
  // spelled out as a span whose two ends the reader has to compare.
  monthYear: {
    year: 'numeric',
    month: 'long',
  },
  // For instants (a payment recorded at, a request filed at): the same day
  // shape plus the time, so a list of things that happened today still reads
  // in order.
  dateTime: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  },
} as const
